import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// Models
import { InvoicesData } from 'src/app/modules/invoices/models/invoices';

// Services
import { UiService } from 'src/app/platform/services/ui.service';
import { InvoicesService } from 'src/app/modules/invoices/invoices.service';

@Component({
  selector: 'app-invoices-email-send',
  templateUrl: './invoices-email-send.component.html',
  styleUrls: ['./invoices-email-send.component.scss']
})
export class InvoicesEmailSendComponent implements OnInit {
  /*public request: boolean = false;
  public invoiceEmailSendFG: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });*/

  constructor(
    private dialog: MatDialogRef<InvoicesEmailSendComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { invoice: InvoicesData },
    private uiService: UiService,
    private invoicesService: InvoicesService,
  ) { }

  ngOnInit(): void { }

  onCancel(): void {
    this.dialog.close();
  }

  onSend(): void {
    this.uiService.showSpinner(true);

    this.invoicesService.emailSend(this.data.invoice.id, this.data.invoice.type).then((result) => {
      this.dialog.close();

      if (result.status) {
        this.uiService.showSpinner(false);
        this.uiService.dialogShow('Factura enviada', 'Enviamos la factura a las direcciones de correo asociadas a tu cuenta..');
      }
      else {
        this.uiService.showSpinner(false);
        this.uiService.dialogShow('Ups!', 'Hubo un inconveniente al intentar enviar la factura. Por favor intenta nuevamente.');
      }
    }, (error) => {
      this.uiService.showSpinner(false);
      this.uiService.dialogShow('Ups!', 'No es posible enviar la factura en este momento. Estamos trabajando para solucionar el inconveniente.');
    });
  }
}
